import { TestListItem, GroupedTestList, DateGroupKey } from "../types/testListTypes";
import { getDateBefore, parseDateOnly } from "../../../utils/CommonUtil";

export const getUniqueValues = (testList: TestListItem[], field: string): string[] => {
  const values = new Set<string>();
  testList.forEach((test) => {
    if (field === "testType") {
      const testTypeValue =
        test.category && test.category !== "VFA" ? test.category : test.testType;
      if (testTypeValue) {
        values.add(String(testTypeValue));
      }
    } else if (test[field]) {
      values.add(String(test[field]));
    }
  });
  return Array.from(values).sort();
};

export const getUniqueBirthYears = (testList: TestListItem[]): number[] => {
  const years = new Set<number>();
  testList.forEach((test) => {
    if (test.patientDob) {
      const year = parseDateOnly(test.patientDob).getFullYear();
      if (year && !isNaN(year)) {
        years.add(year);
      }
    }
  });
  return Array.from(years).sort((a, b) => b - a);
};

export const normalizeDateRange = (
  range: [Date | null, Date | null],
): [Date | null, Date | null] => {
  if (!range || !range[0]) {
    return [null, null];
  }
  if (range[0] && range[1]) {
    const startDate = new Date(range[0]);
    const endDate = new Date(range[1]);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    if (startDate.getTime() === endDate.getTime()) {
      return [range[0], range[0]];
    }
  }
  return range;
};

export const groupTestsByDate = (testList: TestListItem[]): GroupedTestList => {
  const splitedLists: GroupedTestList = {
    today: [],
    week: [],
    month: [],
    year: [],
    older: [],
  };
  const units: DateGroupKey[] = Object.keys(splitedLists) as DateGroupKey[];

  testList.forEach((test) => {
    const startDate = new Date(test.startDate);
    units.forEach((unit, idx) => {
      if (
        startDate.getTime() > getDateBefore(unit).getTime() &&
        (idx === 0 || startDate.getTime() < getDateBefore(units[idx - 1]).getTime())
      ) {
        splitedLists[unit].push(test);
      }
    });
    if (getDateBefore("year").getTime() >= startDate.getTime()) {
      splitedLists.older.push(test);
    }
  });

  return splitedLists;
};
